import bbitApi from '@api/make-request'
import {
  IPathParamsArgs,
  IRepository,
  numberArgs,
} from '@api/repositories/i-repository'
import { IOrganizationLocality } from '@app/interfaces/organization/organization-locality'
import { resolveParams } from '@app/utils/resolve-params/resolve-params'
import { AxiosResponse } from 'axios'

class OrganizationLocalityRepository
  implements IRepository<IOrganizationLocality>
{
  create(
    data: IOrganizationLocality,
  ): Promise<AxiosResponse<IOrganizationLocality>> {
    return bbitApi.post('/dictionary/api/v1/organization-locality', data)
  }

  getAll(
    args: IPathParamsArgs,
  ): Promise<AxiosResponse<IOrganizationLocality[]>> {
    return bbitApi.get('/dictionary/api/v1/organization-locality', {
      cancelToken: args.source?.token,
      params: resolveParams(args),
    })
  }

  getOne(args: numberArgs): Promise<AxiosResponse<IOrganizationLocality>> {
    return bbitApi.get(
      `/dictionary/api/v1/organization-locality/${args.data}`,
      {
        cancelToken: args.source?.token,
      },
    )
  }

  update(
    data: IOrganizationLocality,
  ): Promise<AxiosResponse<IOrganizationLocality>> {
    return bbitApi.put(
      `/dictionary/api/v1/organization-locality/${data.id}`,
      data,
    )
  }
}

export default new OrganizationLocalityRepository()
